import { createAsyncThunk } from '@reduxjs/toolkit';

import { API } from '@/shared/api';
import { TAudioPlotData } from '@/shared/types/AudioPlotData';

export const getOriginalAudioPlotData = createAsyncThunk(
  'audioPlotData/getOriginalAudioPlotData',
  async (path: string) => API.getS3Data<TAudioPlotData>(path),
);
